import * as React from "react";
import { Button, Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { addressCountries } from "../billing/addressData/countries";
import { usaStates } from "../billing/addressData/usaStates";
import { BillingAccount } from "../../schema/types/account";
import { useCpFormAnyValue } from "../gvc/testNewForm/utils";
import { useAppDispatch } from "../../store/hooks";
import { useCpFormContext } from "../../components/form/useCpFormContext";
import { CpAutoComplete } from "../gvc/testNewForm/CpAutoComplete";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../gvc/testNewForm/CpInput";

interface Props {
  account: BillingAccount;
}
export const Address: React.FC<Props> = ({ account }) => {
  const dispatch = useAppDispatch();
  const { submit, id } = useCpFormContext();

  const submitting = useCpFormAnyValue(`meta.submitting`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Address</CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`address.address1`}>Address Line 1</CpLabel>
              <CpInput name={`address.address1`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`address.address1`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`address.address2`}>Address Line 2</CpLabel>
              <CpInput name={`address.address2`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`address.address2`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`address.city`}>City</CpLabel>
              <CpInput name={`address.city`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`address.city`} />
            </CpFormItem>
            {account.address?.country === "United States" ? (
              <CpFormItem>
                <CpLabel name={`address.state`}>State</CpLabel>
                <CpAutoComplete
                  name={`address.state`}
                  options={usaStates.map((v) => ({ label: v, value: v }))}
                  style={{ maxWidth: 600 }}
                />
                <CpErrorWarning name={`address.state`} />
              </CpFormItem>
            ) : (
              <CpFormItem>
                <CpLabel name={`address.state`}>State</CpLabel>
                <CpInput name={`address.state`} style={{ maxWidth: 600 }} />
                <CpErrorWarning name={`address.state`} />
              </CpFormItem>
            )}
            <CpFormItem>
              <CpLabel name={`address.postalCode`}>Zip Code</CpLabel>
              <CpInput name={`address.postalCode`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`address.postalCode`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`address.country`}>Country</CpLabel>
              <CpAutoComplete
                name={`address.country`}
                options={addressCountries.map((v) => ({ label: v, value: v }))}
                style={{ maxWidth: 600 }}
              />
              <CpErrorWarning name={`address.country`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
